import { apiBasePath } from "../constants/constants";
import ApiService from "../utils/api-service";

export function fetchAssessmentQuestionsApi(data) {
  let apiUrl = `${apiBasePath}/assessmentQuestion?max=${
    data?.max ? data?.max : 20
  }`;
  if (
    data?.topicId !== undefined &&
    data?.topicId !== null &&
    data?.topicId !== ""
  ) {
    apiUrl += `&topicId=${data?.topicId}`;
  }
  if (data?.title !== undefined && data?.title !== null && data?.title !== "") {
    apiUrl += `&titleOrDescription=${data?.title}`;
  }
  if (
    data?.type?.length &&
    data?.type !== undefined &&
    data?.type !== null &&
    data?.type !== ""
  ) {
    apiUrl += `&questionTypes=${data?.type}`;
  }
  if (
    data?.difficultyLevel?.length &&
    data?.difficultyLevel !== undefined &&
    data?.difficultyLevel !== null &&
    data?.difficultyLevel !== ""
  ) {
    apiUrl += `&difficultyLevels=${data?.difficultyLevel}`;
  }
  if (
    data?.showActive !== undefined &&
    data?.showActive !== null &&
    data?.showActive !== ""
  ) {
    apiUrl += `&active=${data?.showActive}`;
  }
  if (data?.offset !== undefined) {
    apiUrl += `&offset=${data?.offset}`;
  }
  const options = {
    method: "GET",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}
export function addAssessmentQuestionApi(data) {
  let apiUrl = `${apiBasePath}/assessmentQuestion`;
  if (
    data?.topicId !== undefined &&
    data?.topicId !== null &&
    data?.topicId !== ""
  ) {
    apiUrl += `?topicId=${data?.topicId}`;
  }
  const options = {
    method: "POST",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function editAssessmentQuestionApi(data) {
  let apiUrl = `${apiBasePath}/assessmentQuestion`;
  const options = {
    method: "PATCH",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function toggleQuestionAssessmentApi(id) {
  let apiUrl = `${apiBasePath}/assessmentQuestion/toggleActive?questionId=${id}`;
  const options = {
    method: "POST",
    url: apiUrl,
    data: id,
  };
  return ApiService(options);
}

export function addOptionApi(data) {
  let apiUrl = `${apiBasePath}/assessmentQuestionOption`;
  const options = {
    method: "POST",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function updateOptionApi(data) {
  let apiUrl = `${apiBasePath}/assessmentQuestionOption`;
  const options = {
    method: "PATCH",
    url: apiUrl,
    data: data,
  };
  return ApiService(options);
}

export function deleteOptionApi(id) {
  const options = {
    method: "DELETE",
    url: `${apiBasePath}/assessmentQuestionOption/${id}`,
    data: id,
  };
  return ApiService(options);
}

export function deleteAssessmentQuestionApi(id) {
  const options = {
    method: "DELETE",
    url: `${apiBasePath}/assessmentQuestion/${id}`,
    data: id,
  };
  return ApiService(options);
}

export function getTopicByIdApi(data) {
  const options = {
    method: "GET",
    url: `${apiBasePath}/topics/${data.id}`,
    data: data,
  };
  return ApiService(options);
}

export function getAssessmentQuestionByIdApi({ assessmentQuestionId }) {
  let apiUrl = `${apiBasePath}/assessmentQuestion/${assessmentQuestionId}`;

  const options = {
    method: "GET",
    url: apiUrl,
  };
  return ApiService(options);
}
